module.exports = __webpack_public_path__ + "static/img/warning.08878a87.svg";